const getDefaultState = () => ({
  status: 'idle',
  user: null,
  phone: '',
  error: ''
})

const state = getDefaultState()

const mutations = {
  SET_LOADING(state) {
    state.status = 'loading'
    state.error = ''
  },
  SET_AUTHENTICATED(state, data) {
    state.status = 'authenticated'
    state.user = data.user || null
    state.phone = data.phone || ''
    state.error = ''
  },
  SET_GUEST(state) {
    Object.assign(state, getDefaultState(), { status: 'guest' })
  },
  SET_ERROR(state, message) {
    state.status = 'error'
    state.user = null
    state.phone = ''
    state.error = message || '微信身份初始化失败'
  },
  SET_PHONE(state, phone) {
    state.phone = phone || ''
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
